import { STANDARD, INSTANT, VENDOR } from './constants';
import {
  DROPDOWN,
  CHECKBOX,
  SETTLEMENTS_STATUS_ITEMS,
  SETTLEMENTS_TYPE_ITEMS,
  SETTLEMENTS_VENDOR_STATUS_ITEMS,
} from 'baseConfig/pg/v2/constants';

export default {
  [STANDARD]: {
    TABLE_COLUMNS: [
      {
        key: 'settlementTypeCTA',
        displayName: '',
        width: 0.5,
      },
      {
        key: 'addedOn',
        displayName: 'Initiated At',
        tooltip: 'Initiated At',
        width: 2.5,
        align: 'left',
      },
      {
        key: 'period',
        displayName: 'Transaction Period',
        width: 4,
      },
      {
        key: 'utr',
        displayName: 'UTR',
        width: 2,
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 2,
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 1.5,
      },
    ],
    FILTER_ITEMS: {
      settlementStatus: {
        displayText: 'Status',
        type: DROPDOWN,
        items: SETTLEMENTS_STATUS_ITEMS,
      },
      settlementType: {
        displayText: 'Type',
        type: CHECKBOX,
        items: SETTLEMENTS_TYPE_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'utr',
        text: 'UTR No.',
        value: 'utr',
        placeholder: 'Enter UTR No.',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error: 'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
    ],
  },
  [INSTANT]: {
    TABLE_COLUMNS: [
      {
        key: 'addedOn',
        displayName: 'Date & Time',
        width: 1.6,
        align: 'left',
      },
      {
        key: 'settlementId',
        displayName: 'Settlement ID',
        width: 1.6,
      },
      {
        key: 'transactionAmount',
        displayName: 'Txn. Amt.',
        width: 1.5,
        align: 'right',
      },
      {
        key: 'adjustment',
        displayName: 'Adjustment Amt.',
        width: 1.5,
        align: 'right',
      },
      {
        key: 'charges',
        displayName: 'Charges',
        width: 1.1,
        align: 'right',
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 1.1,
        align: 'right',
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 1.1,
      },
      {
        key: 'settlementLinkCTA',
        displayName: '',
        width: 0.5,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [VENDOR]: {
    TABLE_COLUMNS: [
      {
        key: 'addedOn',
        displayName: 'Date & Time',
        width: 1.5,
        align: 'left',
      },
      {
        key: 'period',
        displayName: 'Period',
        width: 1.2,
      },
      {
        key: 'settlementType',
        displayName: 'Type',
        width: 0.9,
      },
      {
        key: 'merchantVendorId',
        displayName: 'Vendor ID',
        width: 1.2,
      },
      {
        key: 'payoutId',
        displayName: 'Settlement ID',
        width: 1.3,
      },
      {
        key: 'utr',
        displayName: 'UTR No.',
        width: 0.9,
      },
      {
        key: 'adjustmentAmount',
        displayName: 'Adjustment Amt.',
        width: 1.5,
        align: 'right',
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 1.2,
        align: 'right',
      },
      {
        key: 'status',
        displayName: 'Status',
        width: 1.15,
      },
      {
        key: 'failureReason',
        displayName: 'Reason',
        width: 1.1,
      },
      {
        key: 'settlementLinkCTA',
        displayName: '',
        width: 0.5,
      },
    ],
    FILTER_ITEMS: {
      status: {
        displayText: 'Status',
        type: DROPDOWN,
        items: SETTLEMENTS_VENDOR_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'merchantVendorId',
        text: 'Vendor ID',
        value: 'merchantVendorId',
        placeholder: 'Enter Vendor ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error: 'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'payoutId',
        text: 'Settlement ID',
        value: 'payoutId',
        placeholder: 'Enter Settlement ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed.',
      },
      {
        key: 'utr',
        text: 'UTR No.',
        value: 'utr',
        placeholder: 'Enter UTR No.',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error: 'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
    ],
  },
  VENDOR_FOR_SETTLEMENT_V2_UI: {
    TABLE_COLUMNS: [
      {
        key: 'settlementTypeCTA',
        displayName: '',
        width: 0.5,
      },
      {
        key: 'addedOn',
        displayName: 'Initiated At',
        tooltip: 'Initiated At',
        width: 1.5,
        align: 'left',
      },
      {
        key: 'payoutId',
        displayName: 'Vendor ID',
        tooltip: 'Vendor ID',
        width: 1.2,
      },
      {
        key: 'period',
        displayName: 'Payment Range',
        width: 1.8,
      },
      {
        key: 'utr',
        displayName: 'UTR',
        width: 1.3,
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 1.2,
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 2.9,
      },
    ],
  },
};